import { useContext, useEffect, useState } from "react";
import { CorePropsInterfaces, DTOs } from "src/core/Models";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";
import { useTranslation } from "react-i18next";
import { Button, TextField, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AppContext } from "src/contexts/AppContext";
import GtDialog from "./GtDialog";
import * as Constants from "./../../core/Constants";

function GtQuestionComments(
  props: CorePropsInterfaces.GtQuestionCommentsProps
): JSX.Element {
  const { t } = useTranslation();
  const { globalState, dispatch } = useContext(AppContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const existingService = globalState.services.find(
    (s) => s.data.code === props.service.data.code
  );

  const [internalNotes, setInternalNotes] = useState(
    existingService.data.internalNotes || ""
  );
  const [questionCommentsVisibility, setQuestionCommentsVisibility] =
    useState(false);
  const questionsWithComments = props.service.data.questions.filter(
    (question) => !!question.data.comment
  );

  const editInternalNotes = () => {
    const editedService = {
      ...props.service,
      data: {
        ...props.service.data,
        internalNotes: internalNotes,
      },
    };

    setInternalNotes(internalNotes);

    dispatch({
      type: Constants.AppStateActions.ServiceUpdated,
      payload: editedService,
    });
  };

  useEffect(() => {
    setInternalNotes(existingService.data.internalNotes);
  }, [existingService.data.internalNotes]);

  const addDialogDTO: DTOs.GtDialogDTO = {
    data: {
      title: t("General.AddInternalNotes"),
      maxWidth: "xs",
      leftButtons: [],
      rightButtons: [
        <Button
          onClick={() => setIsModalOpen(!isModalOpen)}
          color="inherit"
          variant="contained"
          key="cancelAction"
        >
          {t("General.Cancel")}
        </Button>,
        <Button
          onClick={() => {
            editInternalNotes();
            setIsModalOpen(!isModalOpen);
          }}
          color="tertiary"
          variant="contained"
          key="addInternalNotes"
        >
          {t("General.Save")}
        </Button>,
      ],
    },
    api: {
      onClose: () => setIsModalOpen(!isModalOpen),
    },
    state: {
      isOpen: isModalOpen,
      isFullWidth: true,
    },
  };

  return (
    <article className="gt-questionComments">
      <Tooltip title={t("General.InternalNotes")}>
        <ChatRoundedIcon
          className="gt-questionComments__icon"
          onClick={() => {
            setQuestionCommentsVisibility(!questionCommentsVisibility);
          }}
        />
      </Tooltip>
      {questionCommentsVisibility && (
        <div className="gt-questionComments__text">
          <span className="gt-questionComments__text-title">
            {t("General.InternalNotesFromQuestion")}:
          </span>
          {questionsWithComments.map((question) => (
            <span key={`questionComment${question.data.code}`}>
              {question.data.comment}
            </span>
          ))}
          {questionsWithComments.length === 0 && (
            <span className="gt-questionComments__text-noComment">
              {t("General.NoComments")}
            </span>
          )}

          <div className="gt-questionComments__internalNotes">
            <div
              onClick={() => setIsModalOpen(true)}
              className="gt-questionComments__internalNotes-edit"
            >
              <EditIcon />
              <span className="gt-questionComments__internalNotes-edit-label">
                {t("General.InternalNotesAdding")}
              </span>
            </div>
            {existingService.data.internalNotes && (
              <div className="gt-questionComments__internalNotes-text">
                {existingService.data.internalNotes}
              </div>
            )}
          </div>

          {isModalOpen && (
            <GtDialog gtDialogDTO={addDialogDTO}>
              <TextField
                className="gt-questionComments__text-area"
                multiline
                rows={5}
                onChange={(e) => setInternalNotes(e.target.value)}
                placeholder={t("General.AddInternalNotes")}
                value={internalNotes}
              />
            </GtDialog>
          )}
        </div>
      )}
    </article>
  );
}

export default GtQuestionComments;
